import React, { Component } from 'react';
import { Row, Col, Button, UncontrolledTooltip, Input, Modal, ModalBody, Form } from 'reactstrap';
import { postAPI, getAPI, putAPI } from '../Base/API';
import { StyledCard } from '../Base/Common/CommonUIComponents';
import * as qs from 'query-string';
import { handleNotification } from "../Base/Common/Notification";
import { FormattedMessage, injectIntl } from 'react-intl';
import Authorization from '../Base/Authorization';
import { getPaymentGateways, getValidPaymentMethods, PAYMENT_GATEWAYS } from '../Base/Common/ReferenceDataFunctions';
import { RenderPaymentStatus, RenderReduniqDetails, RenderShift4Details, RenderStripeDetails, RenderValidPaymentMethods, SaveButton, ToggleStatusButton } from './PaymentGatewayComponents';
import { ErrorAlert } from '../Base/ErrorAlert';
import BlockUi from 'react-block-ui';

export class PaymentManagement extends Component {
    static displayName = PaymentManagement.name;
    _isMounted = false;

    constructor(props) {
        super(props);
        this.state = {
            block: false,
            paymentGatewaysTypes: getPaymentGateways().map(pg => ({ code: pg.value, img: pg.logo })),
            selectedGateway: null,
        }
    }

    componentDidMount() {
        const parsed = qs.parse(this.props.location.search);
        let code = parsed.code;
        let scope = parsed.scope;

        if (code != null && scope != null) {
            this.setState({ block: true });

            postAPI(result => {
                const { data, error } = result;

                if (error) {
                    var errorMessage = [];
                    errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                    this.setState({ error: errorMessage, block: false });

                    return;
                }
                if (data) {
                    handleNotification(data, <FormattedMessage id="PaymentManagement.StripeConnected" />, <FormattedMessage id="PaymentManagement.Success" />);
                }
                this.getPaymentGateways();
            }, '/api/Voucher/Payment/v1/CompleteAccountCreation?code=' + code + '&scope=' + scope);
        } else {
            this.getPaymentGateways()
        }
    }

    getPaymentGateways() {
        this.setState({ block: true });
        getAPI(result => {
            const { data, error } = result;

            if (error) {
                var errorMessage = [];
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, block: false });

                return;
            }
            if (data) {
                this.setState({ block: false, paymentGateways: data.response });
            }
        }, '/api/Voucher/Payment/v1/PaymentGateways');
    }

    disconnectStripe() {
        this.setState({ block: true });
        postAPI(result => {
            const { data, error } = result;
            if (error) {
                var errorMessage = [];
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, block: false });
                return;
            }
            if (data && data.response) {
                if (data.response.length > 0) {
                    const respMsg = data.response[0].active ? <FormattedMessage id="PaymentManagement.StripeConnected" /> : <FormattedMessage id="PaymentManagement.StripeDisconnected" />;
                    handleNotification(data, respMsg, <FormattedMessage id="PaymentManagement.Success" />);
                }
                this.setState({ paymentGateways: data.response });
            }
            this.setState({ block: false });
        }, '/api/Voucher/Payment/v1/RevokeAccountConnection');
    }

    setPaymentPaymentStatus(status, code) {
        this.setState({ block: true});
        postAPI(result => {
            const { data, error } = result;
            const errorMessage = [];

            if (error) {
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                this.setState({ error: errorMessage, block: false });
                return;
            }
            if (data) {
                if (data.errors && data.errors.length > 0) {
                    handleNotification(data);
                }
                if (data.response && data.response.length > 0) {
                    handleNotification(data, <FormattedMessage id="PaymentManagement.StatusUpdated" />, <FormattedMessage id="PaymentManagement.Success" />);
                    this.setState({ paymentGateways: data.response });
                }
            }
            this.setState({ error: errorMessage, block: false });
        },`/api/Voucher/Payment/v1/Status?status=${status}&code=${code}`);

    }

    saveGatewayConfig = (e) => {
        if (e) e.preventDefault();

        const { selectedGateway } = this.state;
        if (selectedGateway?.code === PAYMENT_GATEWAYS.REDUNIQ && !selectedGateway.validPaymentModes?.length) {
            this.setState({ error: [{ message: this.props.intl.formatMessage({ id: "PaymentManagement.ValidPaymentModesIsEmpty" }), messageType: 'danger' }] });
            return;
        }

        this.setState({ block: true }, () => {
            putAPI(result => {
                const { data, error } = result;
                const errorMessage = [];

                if (error) {
                    errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                    this.setState(({ block: false, error: errorMessage }));
                    return;
                }
                if (data) {
                    if (data.errors && data.errors.length > 0) {
                        handleNotification(data);
                        this.setState(({ block: false, error: errorMessage }));
                        return;
                    }
                    else if (data.response && data.response.length > 0) {
                        handleNotification(data, <FormattedMessage id="PaymentManagement.GatewayConfigSaved" />, <FormattedMessage id="PaymentManagement.Success" />);
                        this.setState(({ block: false, error: errorMessage, selectedGateway: data.response[0] }), () => this.getPaymentGateways());
                    }
                }
                this.setState(({ block: false, error: errorMessage }));
            }, '/api/Voucher/Payment/v1/PaymentGateway', this.state.selectedGateway);
        });
    }
    
    selectGateway = (gateway) => {
        this.setState({ 
            paymentMode: gateway,
            selectedGateway: this.state.paymentGateways.find(el => el.code === gateway) ?? { code: gateway }
        });
    }

    handleChange = (evt) => {
        const { selectedGateway } = this.state;
        const { name, value } = evt.target;
        
        selectedGateway[name] = value;

        this.setState({ selectedGateway });
    }

    toggleModal = (modalName) => {
        this.setState(prevState => ({
            [modalName]: !prevState[modalName]
        }));
    }   

    updateValidPaymentModes = (evt) => {
        const { selectedGateway } = this.state;
        const { name, checked } = evt.target;

        if (!selectedGateway.validPaymentModes) selectedGateway.validPaymentModes = [];

        if (checked) {
            selectedGateway.validPaymentModes.push(name);
        }
        else {
            selectedGateway.validPaymentModes = selectedGateway.validPaymentModes.filter(pm => pm !== name);
        }

        this.setState({ selectedGateway });
    }

    render() {
        const { paymentGatewaysTypes, selectedGateway } = this.state;

        return (
            <StyledCard icon={'fa-solid fa-credit-card'} title={'PaymentManagement.PaymentGateways'} help={<FormattedMessage id="PaymentManagement.Help" />} id="paymentManagement" error={this.state.error} block={this.state.block}>
                <Row>
                    <Col className="col-6">
                        <hr className="m-0" />
                        {paymentGatewaysTypes?.map((pgc, index) => 
                            <div key={index} >
                                <Row className={this.state.paymentMode === pgc.code ? 'bg-light py-3' : 'bg-white py-3'} style={{ cursor: 'pointer' }} onClick={() => this.selectGateway(pgc.code)}>
                                    <Col>
                                        <img height="40" src={pgc.img}></img>
                                    </Col>
                                    <Col className="text-right">
                                        <RenderPaymentStatus gateway={pgc} paymentGateways={this.state.paymentGateways} />
                                    </Col>
                                </Row>
                                <hr className="m-0" />
                            </div>
                        )}
                    </Col>
                    <Col className="ml-2">
                        {this.state.paymentMode === 'Stripe' ?
                            <>
                                <Row>
                                    <Col>
                                        <h5><FormattedMessage id="PaymentManagement.StripeConnection" /></h5>
                                    </Col>
                                    {selectedGateway ?
                                        <Col className="d-flex align-items-center justify-content-end">                                    
                                            <Authorization
                                                perform="paymentManagement:revoke"
                                                yes={() => (
                                                    <div>
                                                        <Button className="btn btn-host btn-sm ml-2" onClick={this.disconnectStripe.bind(this)} id="revokeTooltip">
                                                            <i className="fa-solid fa-trash-can" />
                                                        </Button>
                                                        <UncontrolledTooltip placement="bottom" target="revokeTooltip">
                                                            <FormattedMessage id="PaymentManagement.RevokeConnection" />
                                                        </UncontrolledTooltip>
                                                    </div>
                                                )}
                                                no={() => <div></div>}
                                            />
    
                                            <ToggleStatusButton
                                                id="disableStripeButton"
                                                onClickFunc={() => this.setPaymentPaymentStatus(!selectedGateway.active, 'Stripe')}
                                                isActive={selectedGateway.active}    
                                            />
                                        </Col>
                                    : ''}
                                </Row>
                                <hr className="mt-1 mb-2" />
                                <RenderStripeDetails paymentGateway={selectedGateway} />
                            </>
                        : ''}
                        {this.state.paymentMode === 'Shift4' ?
                            <>
                                <Row>
                                    <Col>
                                        <h5><FormattedMessage id="PaymentManagement.Shift4Connection" /></h5>
                                    </Col>
                                    <Col className="d-flex align-items-center justify-content-end">
                                        {selectedGateway?.id ?
                                            <ToggleStatusButton 
                                                id="disableShift4Button"
                                                onClickFunc={() => this.setPaymentPaymentStatus(!selectedGateway.active, 'Shift4')}
                                                isActive={selectedGateway.active}    
                                            />
                                        : ''}

                                        <SaveButton onClickFunc={this.saveGatewayConfig} />
                                    </Col>
                                </Row>
                                <hr className="mt-1 mb-2" />

                                <RenderShift4Details
                                    paymentGateway={selectedGateway}
                                    handleChange={this.handleChange}
                                    toggleAccessTokenModal={() => this.toggleModal('accessTokenModal')}
                                />

                                <RenderValidPaymentMethods
                                    validPaymentModes={getValidPaymentMethods(PAYMENT_GATEWAYS.SHIFT4)}
                                    updateValidPaymentModes={this.updateValidPaymentModes}
                                    selectedMethods={selectedGateway?.validPaymentModes}
                                />
                            </>
                        : ''}
                        {this.state.paymentMode === PAYMENT_GATEWAYS.REDUNIQ ?
                            <>
                                <Row>
                                    <Col>
                                        <h5><FormattedMessage id="PaymentManagement.ReduniqConnection" /></h5>
                                    </Col>
                                    <Col className="d-flex align-items-center justify-content-end">
                                        {selectedGateway?.id ?
                                            <ToggleStatusButton
                                                id="disableReduniqButton"
                                                onClickFunc={() => this.setPaymentPaymentStatus(!selectedGateway.active, PAYMENT_GATEWAYS.REDUNIQ)}
                                                isActive={selectedGateway.active}
                                            />
                                        : ''}

                                        <SaveButton onClickFunc={this.saveGatewayConfig} />
                                    </Col>
                                </Row>
                                <hr className="mt-1 mb-2" />

                                <RenderReduniqDetails
                                    paymentGateway={selectedGateway}
                                    handleChange={this.handleChange}
                                    toggleAccessTokenModal={() => this.toggleModal('accessTokenModal')}
                                />

                                <RenderValidPaymentMethods
                                    validPaymentModes={getValidPaymentMethods(PAYMENT_GATEWAYS.REDUNIQ)}
                                    updateValidPaymentModes={this.updateValidPaymentModes}
                                    selectedMethods={selectedGateway?.validPaymentModes}
                                />
                            </>
                        : ''}
                    </Col>
                </Row>

                {this.state.accessTokenModal &&
                    <AccessTokenModal
                        modal={this.state.accessTokenModal}
                        toggleModal={_ => this.toggleModal('accessTokenModal')}
                        paymentGatewayId={selectedGateway?.id}
                    />
                }
            </StyledCard>
        );
    }
}
export default injectIntl(PaymentManagement);


const AccessTokenModal = ({ modal, toggleModal, paymentGatewayId }) => {
    const [block, setBlock] = React.useState(false);
    const [error, setError] = React.useState(null);
    const [accessToken, setAccessToken] = React.useState('');

    const saveAccessToken = (e) => {
        e.preventDefault();

        setBlock(true);

        const body = {
            paymentGatewayId,
            accessToken: accessToken
        };

        postAPI(result => {
            const { data, error } = result;
            var errorMessage = [];

            if (error) {
                const errorMessage = [];
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                setError(errorMessage);
                setBlock(false);
                return;
            }
            if (data) {
                if (data.errors && data.errors.length > 0) {
                    handleNotification(data);
                }
                if (data.response && data.response.length > 0) {
                    handleNotification(data, <FormattedMessage id="PaymentManagement.KeySavedSuccessfully" />, <FormattedMessage id="PaymentManagement.Success" />);
                    toggleModal('accessTokenModal');
                }

                setError(errorMessage);
                setBlock(false);

                return;
            }
            setBlock(false);
        }, '/api/Voucher/Payment/v1/PaymentGateway/SetAccessToken', JSON.stringify({ request: body }) );
    }

    return (    
        <Modal isOpen={modal} toggle={() => toggleModal('accessTokenModal')} className="modal-md">
            <BlockUi tag="div" blocking={block}>
                <ErrorAlert error={error} />
                <Form onSubmit={saveAccessToken}>
                    <ModalBody>
                        <Row className="my-2">
                            <Col>
                                <h5><FormattedMessage id="PaymentManagement.ChangeKey" /></h5>
                            </Col>
                            <Col className="text-right col-2">
                                <Button className="btn btn-host btn-sm" type="submit">
                                    <i className="fa-solid fa-floppy-disk" />
                                </Button>
                            </Col>
                        </Row>
                        <Row className="my-2 text-center">
                            <Col >
                                <Input
                                    type="text"
                                    value={accessToken}
                                    onChange={e => setAccessToken(e.target.value)}
                                    required
                                />
                            </Col>
                        </Row>
                    </ModalBody>
                </Form>
            </BlockUi >
        </Modal>
    )
}